import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { pagesAPI } from '../../lib/api';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import { useSite } from '../../context/SiteContext';

export const DynamicPage = () => {
  const { slug } = useParams();
  const { settings } = useSite();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const response = await pagesAPI.getBySlug(slug);
        setPage(response.data);
      } catch (e) {
        setError('Page not found');
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  useEffect(() => {
    if (page && settings) {
      document.title = `${page.meta_title || page.title} | ${settings.site_name || 'Boostaro'}`;
      
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = page.meta_description || page.title;
    }
  }, [page, settings]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-slate-200 border-t-blue-600" />
      </div>
    );
  }

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
  canonical = document.createElement('link');
  canonical.rel = 'canonical';
  document.head.appendChild(canonical);
  }
  canonical.href = window.location.origin + window.location.pathname;

  if (error || !page) {
    return (
      <div className="min-h-screen bg-slate-50">
        <Header />
        <div className="mx-auto max-w-3xl px-4 py-20 text-center">
          <h1 className="font-heading text-4xl font-bold text-slate-900">Page Not Found</h1>
          <p className="mt-4 text-slate-600">The page you're looking for doesn't exist.</p>
          <Link
            to="/"
            className="mt-6 inline-block btn-cta px-6 py-3 rounded-full font-bold"
          >
            Go Home
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="mx-auto max-w-4xl px-4 py-12">
        <article className="rounded-3xl border border-slate-200 bg-white shadow-lg p-8 md:p-12">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">
            {page.title}
          </h1>
          <div 
            className="mt-8 prose prose-slate max-w-none"
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </article>
      </main>
      
      <Footer />
    </div>
  );
};

export default DynamicPage;
